export const provincias = [{
	"value": "04",
	"text": "Almería"
}, {
	"value": "11",
	"text": "Cádiz"
}, {
	"value": "14",
	"text": "Córdoba"
}, {
	"value": "18",
	"text": "Granada"
}, {
	"value": "21",
	"text": "Huelva"
}, {
	"value": "23",
	"text": "Jaén"
}, {
	"value": "29",
	"text": "Málaga"
}, {
	"value": "41",
	"text": "Sevilla"
}, {
	"value": "22",
	"text": "Huesca"
}, {
	"value": "44",
	"text": "Teruel"
}, {
	"value": "50",
	"text": "Zaragoza"
}, {
	"value": "33",
	"text": "Asturias"
}, {
	"value": "07",
	"text": "Balears, Illes"
}, {
	"value": "35",
	"text": "Palmas, Las"
}, {
	"value": "38",
	"text": "Santa Cruz de Tenerife"
}, {
	"value": "39",
	"text": "Cantabria"
}, {
	"value": "05",
	"text": "Ávila"
}, {
	"value": "09",
	"text": "Burgos"
}, {
	"value": "24",
	"text": "León"
}, {
	"value": "34",
	"text": "Palencia"
}, {
	"value": "37",
	"text": "Salamanca"
}, {
	"value": "40",
	"text": "Segovia"
}, {
	"value": "42",
	"text": "Soria"
}, {
	"value": "47",
	"text": "Valladolvalue"
}, {
	"value": "49",
	"text": "Zamora"
}, {
	"value": "02",
	"text": "Albacete"
}, {
	"value": "13",
	"text": "Ciudad Real"
}, {
	"value": "16",
	"text": "Cuenca"
}, {
	"value": "19",
	"text": "Guadalajara"
}, {
	"value": "45",
	"text": "Toledo"
}, {
	"value": "08",
	"text": "Barcelona"
}, {
	"value": "17",
	"text": "Girona"
}, {
	"value": "25",
	"text": "Llevaluea"
}, {
	"value": "43",
	"text": "Tarragona"
}, {
	"value": "03",
	"text": "Alicante/Alacant"
}, {
	"value": "12",
	"text": "Castellón/Castelló"
}, {
	"value": "46",
	"text": "Valencia/València"
}, {
	"value": "06",
	"text": "Badajoz"
}, {
	"value": "10",
	"text": "Cáceres"
}, {
	"value": "15",
	"text": "Coruña, A"
}, {
	"value": "27",
	"text": "Lugo"
}, {
	"value": "32",
	"text": "Ourense"
}, {
	"value": "36",
	"text": "Pontevedra"
}, {
	"value": "28",
	"text": "Madrvalue"
}, {
	"value": "30",
	"text": "Murcia"
}, {
	"value": "31",
	"text": "Navarra"
}, {
	"value": "01",
	"text": "Araba/Álava"
}, {
	"value": "48",
	"text": "Bizkaia"
}, {
	"value": "20",
	"text": "Gipuzkoa"
}, {
	"value": "26",
	"text": "Rioja, La"
}, {
	"value": "51",
	"text": "Ceuta"
}, {
	"value": "52",
	"text": "Melilla"
}]